export const weekDaysObj = (defaultValue=false) => [
  {
    id: 'd2',
    day:'Monday',
    isChecked: defaultValue
  }, 
  {
    id: 'd3',
    day:'Tuesday',
    isChecked: defaultValue
  }, 
  {
    id: 'd4',
    day:'Wednesday',
    isChecked: defaultValue
  },
  {
    id: 'd5',
    day:'Thursday',
    isChecked: defaultValue
  }, 
  {
    id: 'd6',
    day:'Friday',
    isChecked: defaultValue
  },
  {
    id: 'd7',
    day:'Saturday',
    isChecked: defaultValue
  },
  {
    id: 'd1',
    day:'Sunday',
    isChecked: defaultValue
  },
];

export const timeTile = [
  {
    id: 't1',
    time: '11:00',
    isAmPm: 'AM',
    hour: 11,
    minute: 0
  },
  {
    id: 't2',
    time: '12:00',
    isAmPm: 'PM',
    hour: 12,
    minute: 0
  },
  {
    id: 't3',
    time: '4:00',
    isAmPm: 'PM',
    hour: 4,
    minute: 0
  },
  {
    id: 't4',
    time: '5:00',
    isAmPm: 'PM',
    hour: 5,
    minute: 0
  },
  {
    id: 't5',
    time: '6:00',
    isAmPm: 'PM',
    hour: 6,
    minute: 0
  },
  {
    id: 't6',
    time: '7:00',
    isAmPm: 'PM',
    hour: 7,
    minute: 0
  }];

export const DefaultSelection = {
  days: ['d2','d4','d6'],
  time: 't5',
}

export const BehaviourQuestDefaultWeekSelection = {
  days: ['d2','d3','d4'],
  time: 't1',
}

export const getTimeList = (am_pm = "AM") =>{
  let startTime = 12
  let step = 30, min = 0;
  let timeListLength= 12*(60/step)
  let timeList = [];
  for(let i = 0; i<timeListLength;i++) {
    timeList.push({
      time: startTime + ':' + (min==0 ? '00' : min),
      isAmPm: am_pm,
      hour: startTime,
      minute: min
    });
    if(min+step >= 60 ) {
      min = 0;
      startTime = startTime == 12 ? 1 : startTime+1;
    }
    else {
      min+=step;
    }
  }
  return timeList
}